import { render, staticRenderFns } from "./dashBoard.vue?vue&type=template&id=63c753ea"
import script from "./dashBoard.vue?vue&type=script&lang=js"
export * from "./dashBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports